import { Controller } from "@hotwired/stimulus"

// Narrows a long checkbox list down to the rows whose label matches a text
// query, entirely client-side — built for the staff-client assignment
// picker (many Clients, one text box) but generic enough for any checkbox
// list that grows too long to scan by eye.
//
// Each row carries its own searchable text in `data-checkbox-filter-name-param`
// (lowercased ahead of time so filtering never re-derives it from live DOM
// text); the query input just toggles `hidden` on non-matching rows, so a
// checked-but-filtered-out row stays checked and still submits with the form.
export default class extends Controller {
  static targets = ["query", "row"]

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      const name = row.dataset.checkboxFilterNameParam || ""
      row.hidden = query.length > 0 && !name.includes(query)
    })
  }
}
